'use client';
import { Slide, ToastContainer } from 'react-toastify';

import { Svg } from '@/components';
import { SuccessTickCircleIcon, CrossCircleIcon } from '@/icons';
import 'react-toastify/dist/ReactToastify.css';

const Toast = () => {
  return (
    <ToastContainer
      closeOnClick
      autoClose={3000}
      position='bottom-center'
      // limit={1}
      hideProgressBar
      pauseOnFocusLoss={false}
      closeButton={false}
      newestOnTop={false}
      rtl={false}
      draggable
      pauseOnHover
      transition={Slide}
      icon={({ type }) => {
        if (type === 'success') {
          return (
            <Svg
              width='45'
              height='44'
              viewBox='0 0 45 44'
              className='h-8 w-8 stroke-none stroke-0'>
              <SuccessTickCircleIcon />
            </Svg>
          );
        }

        return (
          <Svg
            fill='none'
            width='80'
            height='80'
            viewBox='0 0 80 80'
            className='mx-auto h-8 w-8 stroke-none'>
            <CrossCircleIcon />
          </Svg>
        );
      }}
    />
  );
};

export default Toast;
